import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    height: 30,
    margin: theme.spacing(5, 0, 2, 0),
    fontSize: 24,
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.25,
    letterSpacing: 'normal',
    color: theme.colorPalette.green_90
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(6)
  },
  button: {
    width: '100%',
    fontWeight: 600,
    fontSize: 14
  },
  textButton: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: 14
  },
  actionButtonIcon: {
    marginRight: 8
  }
}));

export default useStyles;
